import { FieldTypes } from '../modules/tables/types';
import { UnderlineStyleEnum } from './types';

export const UNDERLINE_COLOURS: UnderlineStyleEnum[] = [
  'Blue',
  'Purple',
  'Orange',
  'Green',
  'Red',
];

export const SCROLLABLE_PACE = 10;

export const NOTIFICATION_DURATION = 6000;

export const SHOULD_EXPAND_MULTI_SELECT_AFTER = 10;
export const CELL_DROPDOWN_Y_OFFSET = 8;
export const CELL_DROPDOWN_X_OFFSET = 8;
export const EXPANDED_CELL_DROPDOWN_Y_OFFSET = 29;
export const EXPANDED_MODAL_DROPDOWN_Y_OFFSET = 32;

export const REFERENCE_DROPDOWN_OPTIONS = 20;
export const FILTER_DROPDOWN_OPTIONS = 20;

export const REFERENCE_FIELDS: FieldTypes[] = ['single-reference', 'multi-reference'];
export const UNSORTABLE_FIELD_TYPES: FieldTypes[] = [...REFERENCE_FIELDS];
export const UNFILTERABLE_FIELD_TYPES: FieldTypes[] = [
  'long-text',
  'json',
  'image',
  'time',
  'date-time',
  'date',
];
